import axios from "axios";
import React, { useEffect, useState } from "react";

const AddCategories = () => {
  const [category, setCategory] = useState("");
  const [error, setError] = useState("");
  const [brandList, setBrandList] = useState([]);
  const [success, setSuccess] = useState(false);
  const [selectBrand, setSelectBrand] = useState("");
  const [subCategory, setSubCategory] = useState("");
  const [selectBrandCat, setSelectBrandCat] = useState([]);
  const [selectCatBrand, setSelectCatBrand] = useState("");
  const [brCategory, setBrCategory] = useState([]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const data = {
      category,
      brand: selectBrand,
      subCategory,
    };

    try {
      const response = await axios.post("/add-category", data);
      setSuccess(response.data);
      setCategory("");
    } catch (error) {
      setError("Faild");
      return;
    }
  };
  setTimeout(() => {
    setSuccess(false);
  }, 1000);

  useEffect(() => {
    const getBrand = async () => {
      try {
        const response = await axios.get("/get-brand");
        setBrandList(response.data);
      } catch (error) {
        return;
      }
    };
    getBrand();
  }, []);


  useEffect(() => {
    if (!selectCatBrand) {
      return;
    }
    const getAllCategory = async () => {
      try {
        const response = await axios.get("/get-brand-category", {
          params: {
            brand: selectCatBrand,
          },
        });
        setSelectBrandCat(response.data);
      } catch (error) {
        return;
      }
    };
    getAllCategory();
  }, [selectCatBrand]);

  const addSubCategory = async (e) => {
    e.preventDefault();

    const data = {
      subCategory,
    };
    try {
      const response = await axios.put(
        `/update-subcategory/${selectCatBrand}/${brCategory}`,
        data
      );
      response(setSubCategory(""))
    } catch (error) {
      return;
    }
  };

  return (
    <div className="main_wrp">
      <div className="main_page_wrp">
        <div className="head_wrp">
          <h5>
            Add <em>Category</em>
          </h5>
        </div>
        <div className="main_body_wrp">
          <form onSubmit={handleSubmit}>
            <div className="add_main">
              <div className="add_t_form">
                <div className="in_main">
                  <label>Brand</label>
                  <select
                    value={selectBrand}
                    onChange={(e) => setSelectBrand(e.target.value)}
                  >
                    <option value="">-- Select Brand --</option>
                    {brandList.map((brand, i) => (
                      <option key={i} value={brand.brand}>
                        {brand.brand}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="in_main">
                  <label>Category</label>
                  <input
                    value={category}
                    onChange={(e) => setCategory(e.target.value)}
                    required
                  />
                </div>
              </div>

              <div>
                <button type="submit" className="btn_submit_form">
                  <span>Add</span>
                </button>
              </div>

              {error && <small style={{ color: "red" }}>{error}</small>}
              {success && (
                <small style={{ color: "green" }}>
                  Product added successfully!
                </small>
              )}
            </div>
          </form>
          <br />
          <h6>Add Sub Category</h6>
          <form onSubmit={addSubCategory}>
            <div className="add_main">
              <div className="add_t_form">
                <div className="in_main">
                  <label>Brand</label>
                  <select
                    value={selectCatBrand}
                    onChange={(e) => setSelectCatBrand(e.target.value)}
                  >
                    <option value="">-- Select Brand --</option>
                    {brandList.map((brand, i) => (
                      <option key={i} value={brand.brand}>
                        {brand.brand}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="in_main">
                  <label>Category</label>

                  <select
                    value={brCategory}
                    onChange={(e) => setBrCategory(e.target.value)}
                  >
                    <option value="">-- Select Brand --</option>
                    {selectBrandCat.map((category, i) => (
                      <option key={i} value={category.category}>
                        {category.category}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="in_main">
                  <label>Sub Category</label>
                  <input
                    value={subCategory}
                    onChange={(e) => setSubCategory(e.target.value)}
                  />
                </div>
              </div>

              <div>
                <button type="submit" className="btn_submit_form">
                  <span>Add</span>
                </button>
              </div>

              {error && <small style={{ color: "red" }}>{error}</small>}
              {success && (
                <small style={{ color: "green" }}>
                  Product added successfully!
                </small>
              )}
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddCategories;
